$(function () {
  if (!customElements.get('lt-header')) {
    customElements.define(
      'lt-header',
      class ltHeader extends HTMLElement {
        constructor() {
          super();
          this.$ltHeader = null;
          this.$headerContainer = null;
          this.$header = null;
          this.$announcement = null;
          this.$announcementHeight = null;
          this.$scrollThreshold = 50; // 设置滚动阈值
          this.$menuContainer = null; //菜单列表
          this.$MainContent = null;
          this.$overlay = null;
          this.$hasMenuFunctionBeenCalled = false;
          this.$mobileMenu = null;
          this.$mobileMenuShow = null;
          this.$mobilePopup = null;
          this.$header01 = null;
          this.$scrollShow = true;
          this.$loginButton = null;
          this.$body = null;
          this.$bubbleContainerList = null;
          this.$lastScrollTop = 0;
          this.$navHeader = null;
          this.$navflag = false; // 导航是否开启
          this.$observer = null;
          this.$screen = null;
          this.$theme = null;
          this.$currentInfo = {};
          this.$defaultScreen = null;
          this.$scrollBtnContainer = null;
        }

        connectedCallback() {
          this.$body = $('body');
          this.$header = this.querySelector('#header-01');
          this.$ltHeader = $('#lt-header')[0];
          this.$headerLayout = this.querySelector('.nav-layout');
          this.$defaultScreen = this.$ltHeader.getAttribute('data-defaultScreen'); //是否开启
          this.$bubbleContainerList = this.querySelectorAll('.bubble-container');
          this.announcement = $('#announcement');
          this.$headerContainer = $('.header-01');
          this.$menuContainer = this.querySelector('.header-container');
          this.$MainContent = $('#MainContent');
          this.init();
          this.currentScreen();
          this.$prevBtn = this.querySelector('.scroll-btn-container .swiper-button-prev');
          this.$nextBtn = this.querySelector('.scroll-btn-container .swiper-button-next');
          this.$scroller = this.querySelector('.nav-scroller');

          this.$scrollBtnContainer = this.querySelector('.scroll-btn-container');
          this.$prevBtn.addEventListener('click', () => this.scrollTo('swiper-button-prev'));
          this.$nextBtn.addEventListener('click', () => this.scrollTo('swiper-button-next'));
          this.$scroller.addEventListener('scroll', () => this.updateButtons());

          // 添加鼠标悬浮事件
          if (this.$scrollBtnContainer) {
            this.$scrollBtnContainer.addEventListener('mouseenter', () => {
              this.$ltHeader.setAttribute('data-screen', false);
              this.$headerLayout.classList.remove('text-white');
            });
          }

          // 使用防抖处理 resize 事件
          const debouncedUpdate = debounce(() => {
            requestAnimationFrame(() => {
              this.updateButtons();
            });
          }, 100);

          window.addEventListener('resize', debouncedUpdate);

          // 初始化时就设置按钮状态
          requestAnimationFrame(() => {
            this.updateButtons();
          });

          // 获取所有导航项
          const navItems = this.querySelectorAll('[data-nav-type]');

          // 为每个导航项添加hover监听
          navItems.forEach((item) => {
            let isInitialized = false;
            const navType = item.dataset.navType;
            const jsUrl = item.dataset.jsUrl;
            const navLaunch = item.querySelector('.nav-launch');

            item.addEventListener('mouseenter', () => {
              // 对于需要加载JS的导航类型
              if (!isInitialized && jsUrl && navLaunch) {
                litime.initWhenVisible({
                  element: navLaunch,
                  callback: () => {
                    // 动态加载对应的JS文件
                    const script = document.createElement('script');
                    script.src = jsUrl;
                    script.onload = () => {
                      loadNavImages(navType, navLaunch, item);
                    };
                    document.head.appendChild(script);
                  },
                  threshold: 0,
                });
                isInitialized = true;
              }
              // 对于不需要加载JS的导航类型
              else if (!isInitialized && navLaunch) {
                litime.initWhenVisible({
                  element: navLaunch,
                  callback: () => {
                    loadNavImages(navType, navLaunch, item);
                  },
                  threshold: 0,
                });
                isInitialized = true;
              }
            });
          });

          // 抽取图片加载逻辑为单独的函数
          const loadNavImages = (navType, navLaunch, currentItem) => {
            // 加载当前导航中的图片
            const lazyImages = navLaunch.querySelectorAll('.nav-lazy-image');
            console.log('Current nav lazy images:', lazyImages);
            lazyImages.forEach((img) => {
              if (img.dataset.src) {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
              }
            });

            // 同时加载相同类型导航中的图片
            const sameTypeNavs = document.querySelectorAll(`[data-nav-type="${navType}"]`);
            console.log('Same type navs:', sameTypeNavs);
            sameTypeNavs.forEach((nav) => {
              if (nav !== currentItem) {
                const images = nav.querySelectorAll('.nav-lazy-image');
                console.log('Other nav lazy images:', images);
                images.forEach((img) => {
                  if (img.dataset.src) {
                    img.src = img.dataset.src;
                    img.removeAttribute('data-src');
                  }
                });

                // 显示其他相同类型的导航
                const launch = nav.querySelector('.nav-launch');
                if (launch) {
                  launch.classList.remove('navLaunchNo');
                  launch.classList.add('navLaunchShow');
                }
              }
            });
          };

          if (this.$menuContainer && this.$menuContainer.querySelectorAll('li[data-target]').length > 0)
            this.mouseLeaveHandler();
        }
        static get observedAttributes() {
          return ['data-theme', 'data-screen'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (oldValue === newValue) return;

          if (name === 'data-screen') {
            if (newValue == 'false') {
              // 确保处理布尔值或字符串
              if (this.$header) {
                this.$header.classList.add('theme-light-current');
              }

              this.$screen = false;
              return; // 直接退出，不执行后续逻辑
            } else if (newValue == 'true' || newValue == true) {
              this.$screen = true;
              if (this.$header) {
                this.$header.classList.remove('theme-light-current');
              }
            }
          }

          if ((this.$screen === true || this.$screen === 'true') && name === 'data-theme') {
            if (this.$header) {
              if (name === 'data-theme' && newValue === 'light') {
                this.$header.classList.remove('theme-dark');
                this.$header.classList.add('theme-light');
                this.$headerLayout.classList.remove('text-white');
                this.$bubbleContainerList.forEach((res) => {
                  const dataLightColor = res.getAttribute('data-light-color').split(',');
                  res.style.background = dataLightColor[0];
                  res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                  res.querySelector('span').style.color = dataLightColor[1];
                });
              } else if (name === 'data-theme' && newValue === 'dark') {
                this.$header.classList.remove('theme-light');
                this.$header.classList.add('theme-dark');
                this.$headerLayout.classList.add('text-white');
                this.$bubbleContainerList.forEach((res) => {
                  const dataDarkColor = res.getAttribute('data-dark-color').split(',');
                  res.style.background = dataDarkColor[0];
                  res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataDarkColor[0]}`;
                  res.querySelector('span').style.color = dataDarkColor[1];
                });
              }
            }
          } else if (name === 'data-screen' && (this.$screen === true || this.$screen === 'true')) {
            if (this.$currentInfo.name === 'data-theme' && this.$currentInfo.value === 'light') {
              this.$header.classList.remove('theme-dark');
              this.$header.classList.add('theme-light');
              this.$bubbleContainerList.forEach((res) => {
                const dataLightColor = res.getAttribute('data-light-color').split(',');
                res.style.background = dataLightColor[0];
                res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                res.querySelector('span').style.color = dataLightColor[1];
              });
            } else if (this.$currentInfo.name === 'data-theme' && this.$currentInfo.value === 'dark') {
              this.$header.classList.remove('theme-light');
              this.$header.classList.add('theme-dark');
              this.$bubbleContainerList.forEach((res) => {
                const dataDarkColor = res.getAttribute('data-dark-color').split(',');
                res.style.background = dataDarkColor[0];
                res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataDarkColor[0]}`;
                res.querySelector('span').style.color = dataDarkColor[1];
              });
            }
          }
          if (name == 'data-theme') {
            this.$currentInfo = { name: name, value: newValue };
          }
        }

        currentScreen() {
          this.$screen = this.$ltHeader.getAttribute('data-screen');
          this.$theme = this.$ltHeader.getAttribute('data-theme');
          if (window.location.pathname !== '/') {
            this.$screen = false;
            this.$theme = 'light';
            this.$ltHeader.setAttribute('data-screen', false);
            this.$ltHeader.setAttribute('data-theme', 'light');
          }

          if (this.$screen != 'false' || this.$screen == true) {
            if (this.$theme == 'light') {
              this.$header.classList.remove('theme-dark');
              this.$header.classList.add('theme-light');
              this.$headerLayout.classList.remove('text-white');
              this.$bubbleContainerList.forEach((res) => {
                const dataLightColor = res.getAttribute('data-light-color').split(',');
                res.style.background = dataLightColor[0];
                res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                res.querySelector('span').style.color = dataLightColor[1];
              });
            } else if (this.$theme == 'dark') {
              this.$header.classList.remove('theme-light');
              this.$header.classList.add('theme-dark');
              this.$headerLayout.classList.add('text-white');
              this.$bubbleContainerList.forEach((res) => {
                const dataDarkColor = res.getAttribute('data-dark-color').split(',');
                res.style.background = dataDarkColor[0];
                res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataDarkColor[0]}`;
                res.querySelector('span').style.color = dataDarkColor[1];
              });
            }
          } else {
            this.$screen = false;
            this.$header.classList.add('theme-light');
            this.$ltHeader.setAttribute('data-screen', false);
            this.$ltHeader.setAttribute('data-theme', 'light');
          }
        }

        disconnectedCallback() {
          window.overlayManager.hide('header'); // 确保清理遮罩层
          // 监听窗口大小变化事件
          window.removeEventListener('resize', this.handleResize);
          // 移除事件监听
          this.removeHoverMenuListeners();
          if (this.$observer) {
            this.$observer.disconnect(); // 停止监听
          }
        }

        init() {
          this.mobilePopupFunction();
          // 开启了通屏为透明导航得时候才可以进来
          if (this.$header && this.$header.classList.contains('bg-transparent')) {
          }
          this.scroll();
          this.handleResize();
          this.mobileMenuClick();

          // 添加header-right-container的鼠标事件
          const headerRightContainer = this.querySelector('.header-right-container');
          if (headerRightContainer) {
            headerRightContainer.addEventListener('mouseenter', () => {
              window.overlayManager.hide('header');
              this.$navflag = false;

              if (window.innerWidth > 1200 && window.location.pathname === '/') {
                if (this.$scrollShow == true) {
                  if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                    this.$ltHeader.setAttribute('data-screen', true);
                  }
                }
                this.$theme = this.$ltHeader.getAttribute('data-theme');
                if (this.$theme == 'dark') {
                  if (this.$ltHeader.getAttribute('data-screen') == true) {
                    this.$headerLayout.classList.add('text-white');
                  } else {
                    this.$headerLayout.classList.remove('text-white');
                  }
                } else {
                  this.$headerLayout.classList.remove('text-white');
                }
              }

              const navItems = this.$menuContainer.querySelectorAll('li[data-target]');
              navItems.forEach((item) => {
                item.classList.remove('nav-item-active');
                const targetSelector = item.querySelector('.nav-launch');
                if (targetSelector) {
                  targetSelector.classList.remove('nav-hover-active');
                }
              });
              const navLaunches = this.$menuContainer.querySelectorAll('.nav-launch');
              navLaunches.forEach((launch) => {
                launch.classList.remove('navLaunchShow');
                launch.classList.add('navLaunchNo');
              });
            });
          }

          if (this.$menuContainer && this.$menuContainer.querySelectorAll('li[data-target]').length > 0) {
            this.mouseLeaveHandler();
          }

          // 监听窗口大小变化
          window.addEventListener('resize', () => {
            // 当窗口尺寸改变时，重新检查并执行
            if (window.innerWidth >= 1200) {
              // 如果已经执行过 hoverMenuFunction，则不再重复执行
              if (!this.$hasMenuFunctionBeenCalled) {
                this.handleResize();
                this.$hasMenuFunctionBeenCalled = true; // 设置标志
              }
            } else {
              window.removeEventListener('resize', this.handleResize);
              this.removeHoverMenuListeners();
              // 如果窗口小于 1200px，可以重置标志，以便窗口重新变大时再次执行
              this.$hasMenuFunctionBeenCalled = false;
            }
          });
        }

        handleResize() {
          if (window.innerWidth >= 1200 && !this.$hasMenuFunctionBeenCalled) {
            this.hoverMenuFunction();
            this.$hasMenuFunctionBeenCalled = true;
          } else {
            this.$hasMenuFunctionBeenCalled = false;
          }
        }

        hoverMenuFunction() {
          const navItems = this.$menuContainer.querySelectorAll('li[data-target]');
          this.eventHandlers = []; // 存储事件处理程序

          navItems.forEach((item) => {
            const targetSelector = item.querySelector('.nav-launch');
            const mouseEnterHandler = () => {
              // 确保每次触发前清除所有存在的遮罩层
              this.clearExistingOverlays();

              navItems.forEach((res) => {
                res.classList.remove('nav-item-active');
              });
              item.classList.add('nav-item-active');

              // 移入进来将设置的当前通屏颜色关闭
              this.$ltHeader.setAttribute('data-screen', false);
              this.$headerLayout.classList.remove('text-white');
              this.$bubbleContainerList.forEach((res) => {
                const dataLightColor = res.getAttribute('data-light-color').split(',');
                res.style.background = dataLightColor[0];
                res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                res.querySelector('span').style.color = dataLightColor[1];
              });
              const dataTarget = item.getAttribute('data-target');
              if (dataTarget !== '.menu-plan-3') {
                if (this.$MainContent.length > 0) {
                  // 使用全局遮罩层管理器
                  this.$overlay = window.overlayManager.show('header');
                }

                // 获取所有的 .nav-launch 元素，并将其全部隐藏
                const allNavLaunches = this.$menuContainer.querySelectorAll('.nav-launch');
                allNavLaunches.forEach((launch) => {
                  launch.classList.add('navLaunchNo');
                  launch.classList.remove('navLaunchShow');
                });
                if (!this.$navflag) {
                  // 显示当前菜单项的 .nav-launch
                  if (targetSelector) {
                    this.$navflag = true;
                    targetSelector.classList.add('navLaunchShow');
                    targetSelector.classList.remove('navLaunchNo');
                  }
                } else {
                  // 平级切换
                  targetSelector.classList.remove('navLaunchNo');
                  targetSelector.classList.add('nav-hover-active');
                }
              } else if (dataTarget === '.menu-plan-3') {
                window.overlayManager.hide('header'); // 使用全局遮罩层管理器隐藏遮罩层
                const navLaunch = $('.nav-launch');
                this.$navflag = false;
                navItems.forEach((item) => {
                  item.classList.remove('nav-item-active');
                  const targetSelector = item.querySelector('.nav-launch');
                  if (targetSelector) {
                    targetSelector.classList.remove('nav-hover-active');
                  }
                });
                navLaunch.each((index, element) => {
                  element.classList.remove('navLaunchShow');
                  element.classList.add('navLaunchNo');
                });
              }
            };
            item.addEventListener('mouseenter', mouseEnterHandler);
            this.eventHandlers.push({ item, mouseEnterHandler });
          });
        }
        closePopup() {
          window.overlayManager.hide('header');
          this.$navflag = false;

          if (window.innerWidth > 1200 && window.location.pathname === '/') {
            if (this.$scrollShow == true) {
              if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                this.$ltHeader.setAttribute('data-screen', true);
              }
            }
          }
          const navItems = this.$menuContainer.querySelectorAll('li[data-target]');
          navItems.forEach((item) => {
            item.classList.remove('nav-item-active');
          });
          const navLaunches = this.$menuContainer.querySelectorAll('.nav-launch');
          navLaunches.forEach((launch) => {
            launch.classList.remove('navLaunchShow');
            launch.classList.add('navLaunchNo');
          });
        }
        // 移出事件
        mouseLeaveHandler() {
          customEventListener(this.$headerContainer[0], 'mouseleave', () => {
            window.overlayManager.hide('header');
            this.$navflag = false;

            if (window.innerWidth > 1200 && window.location.pathname === '/') {
              if (this.$scrollShow == true) {
                if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                  this.$ltHeader.setAttribute('data-screen', true);
                }
              }
              this.$theme = this.$ltHeader.getAttribute('data-theme');
              if (this.$theme == 'dark') {
                if (
                  this.$ltHeader.getAttribute('data-screen') == true ||
                  this.$ltHeader.getAttribute('data-screen') == 'true'
                ) {
                  this.$headerLayout.classList.add('text-white');
                } else {
                  this.$headerLayout.classList.remove('text-white');
                }
              } else {
                this.$headerLayout.classList.remove('text-white');
              }
            }

            const navItems = this.$menuContainer.querySelectorAll('li[data-target]');
            navItems.forEach((item) => {
              item.classList.remove('nav-item-active');
              const targetSelector = item.querySelector('.nav-launch');
              if (targetSelector) {
                targetSelector.classList.remove('nav-hover-active');
              }
            });
            const navLaunches = this.$menuContainer.querySelectorAll('.nav-launch');
            navLaunches.forEach((launch) => {
              launch.classList.remove('navLaunchShow');
              launch.classList.add('navLaunchNo');
            });
          });
        }

        // 用于移除事件监听器
        removeHoverMenuListeners() {
          if (this.eventHandlers) {
            this.eventHandlers.forEach(({ item, mouseEnterHandler }) => {
              item.removeEventListener('mouseenter', mouseEnterHandler);
            });
          }
        }

        scroll() {
          // 监听滚动事件
          $(window).on('scroll', () => {
            if ($(window).scrollTop() > this.$lastScrollTop) {
              this.$headerContainer.removeClass('header-01-sticky');
              if ($(window).scrollTop() > this.$scrollThreshold) {
                this.$headerContainer.addClass('header-01-out');
                this.$ltHeader.setAttribute('data-scrollShow', false);
                this.$headerLayout.classList.remove('text-white');
              }
            } else if ($(window).scrollTop() < this.$lastScrollTop) {
              if ($(window).scrollTop() > this.$scrollThreshold) {
                this.$headerContainer.addClass('header-01-sticky');
                this.$headerContainer.removeClass('header-01-out');
                this.$ltHeader.setAttribute('data-scrollShow', true);
                this.$headerLayout.classList.remove('text-white');
              }
            }
            this.$lastScrollTop = $(window).scrollTop(); // 更新上一次的滚动位置

            // 公告栏存在超出公告栏的高度时显示背景颜色
            if (this.announcement.length > 0) {
              if ($(window).scrollTop() > this.announcement.height()) {
                this.$header.classList.remove('bg-transparent', 'border-transparent');
                this.$header.classList.add('bg-white', 'header-light');

                this.$bubbleContainerList.forEach((res) => {
                  const dataLightColor = res.getAttribute('data-light-color').split(',');
                  res.style.background = dataLightColor[0];
                  res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                  res.querySelector('span').style.color = dataLightColor[1];
                });

                if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                  this.$ltHeader.setAttribute('data-screen', false);
                  this.$scrollShow = false;
                }
                this.$headerLayout.classList.remove('text-white');
              } else {
                // 如果滚动距离小于阈值，则恢复透明背景
                this.$header.classList.remove('bg-white', 'header-light', 'light-default');
                this.$header.classList.add('bg-transparent');
                if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                  this.$ltHeader.setAttribute('data-screen', true);
                  this.$scrollShow = true;
                }
                this.$theme = this.$ltHeader.getAttribute('data-theme');
                if (this.$theme == 'dark') {
                  if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                    this.$headerLayout.classList.add('text-white');
                  } else {
                    this.$headerLayout.classList.remove('text-white');
                  }
                } else {
                  this.$headerLayout.classList.remove('text-white');
                }
              }
            } else if ($(window).scrollTop() > this.$scrollThreshold) {
              this.$header.classList.remove('bg-transparent', 'border-transparent');
              this.$header.classList.add('bg-white', 'header-light');
              if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                this.$scrollShow = false;
                this.$ltHeader.setAttribute('data-screen', false);
              }
              this.$headerLayout.classList.remove('text-white');

              this.$bubbleContainerList.forEach((res) => {
                const dataLightColor = res.getAttribute('data-light-color').split(',');
                res.style.background = dataLightColor[0];
                res.querySelector('.left-triangle').style.borderRight = `6px solid ${dataLightColor[0]}`;
                res.querySelector('span').style.color = dataLightColor[1];
              });
            } else {
              if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                this.$scrollShow = true;
                this.$ltHeader.setAttribute('data-screen', true);
              }
              this.$theme = this.$ltHeader.getAttribute('data-theme');

              this.$headerLayout.classList.remove('text-white');
              // 如果滚动距离小于阈值，则恢复透明背景
              this.$header.classList.remove('bg-white', 'header-light');
              this.$header.classList.add('bg-transparent');
              this.$header.classList.add('border-transparent');
            }
          });

          // 初始状态设置
          if (this.announcement.length > 0) {
            this.$headerContainer.addClass('header-01-sticky');
            this.$headerContainer.removeClass('header-01-out');

            if ($(window).scrollTop() > this.announcement.height()) {
              this.$header.classList.remove('bg-transparent', 'border-transparent');
              this.$header.classList.add('bg-white', 'header-light', 'light-default');
              this.$ltHeader.setAttribute('data-screen', true);
            } else if ($(window).scrollTop() > this.$scrollThreshold) {
              this.$header.classList.remove('bg-transparent', 'border-transparent');
              this.$header.classList.add('bg-white');
            }
          } else {
            if ($(window).scrollTop() > this.announcement.height()) {
              this.$headerContainer.addClass('header-01-sticky');
              this.$headerContainer.removeClass('header-01-out');
              this.$header.classList.remove('bg-transparent', 'border-transparent');
              this.$header.classList.add('bg-white', 'header-light', 'light-default');
            }
            this.$ltHeader.setAttribute('data-screen', true);
          }
        }

        // 打开移动端菜单
        mobileMenuClick() {
          this.$mobileMenu = this.querySelector('.mobileMenu');
          this.$header01 = this.querySelector('#header-01');
          this.$mobileMenuShow = this.querySelector('.mobileMenuShow');
          this.$mobilePopup = this.querySelector('.mobilePopup');
          this.$navHeader = $('.nav-header')[0];
          customEventListener(this.$mobileMenu, 'click', () => {
            if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
              this.$screen = false;
              this.$ltHeader.setAttribute('data-screen', false);
            }
            this.$body.addClass('body-no-scroll');
            this.$header.classList.add('theme-light-current');
            //首先判断            this.announcement有没有并且他的宽度需要大于0之后因为他的高度也是js计算的可能没那么快然后在添加this.announcement.addClass('hidden');
            if (this.announcement && this.announcement.height() > 0) {
              this.announcement.addClass('hidden');
            }
            this.$mobileMenu.classList.remove('flex');
            this.$mobileMenu.classList.add('hidden');
            this.$mobileMenuShow.classList.remove('hidden');
            this.$mobileMenuShow.classList.add('flex');
            this.$mobilePopup.classList.remove('hidden');
            this.$mobilePopup.classList.add('block');
            this.$header01.classList.add('mobile-dark');
            this.$body.add('body-no-scroll');

            this.$navHeader.classList.add('bg-white');
            const ellipse = this.$navHeader.querySelectorAll('.svg-light svg ellipse');
            const svgPath = this.$navHeader.querySelectorAll('.svg-path');
            if (ellipse) {
              ellipse.forEach((res) => {
                res.style.stroke = '#191919'; // 使用 style 修改 stroke 颜色
              });
            }
            if (svgPath) {
              svgPath.forEach((res) => {
                res.style.stroke = '#191919'; // 使用 style 修改 stroke 颜色
              });
            }
            this.$header01.classList.add('fixed', 'top-0', 'left-0', 'w-full', 'h-full');
          });
          customEventListener(this.$mobileMenuShow, 'click', () => {
            if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
              this.$screen = true;
              this.$ltHeader.setAttribute('data-screen', true);
            }

            this.announcement.removeClass('hidden');
            this.$body.removeClass('body-no-scroll');
            this.$mobileMenu.classList.remove('hidden');
            this.$mobileMenu.classList.add('flex');
            this.$navHeader.classList.remove('bg-white');
            this.$mobileMenuShow.classList.remove('flex');
            this.$mobileMenuShow.classList.add('hidden');
            this.$mobilePopup.classList.remove('block');
            this.$mobilePopup.classList.add('hidden');
            this.$header01.classList.remove('mobile-dark');
            this.$header01.classList.remove('fixed', 'top-0', 'left-0', 'h-full');
            const ellipse = this.$navHeader.querySelectorAll('.svg-light svg ellipse');
            const svgPath = this.$navHeader.querySelectorAll('.svg-path');
            if (ellipse) {
              ellipse.forEach((res) => {
                res.style.stroke = ''; // 使用 style 修改 stroke 颜色
              });
            }
            if (svgPath) {
              svgPath.forEach((res) => {
                res.style.stroke = ''; // 使用 style 修改 stroke 颜色
              });
            }
          });
        }
        mobilePopupFunction() {
          // 获取 mobilePopup 元素

          // 定义 resize 事件处理逻辑
          const resizeHandler = () => {
            // 检查窗口宽度
            if (window.innerWidth > 1200) {
              // 如果宽度大于 1200px，隐藏 mobilePopup
              if (this.$mobilePopup) {
                this.$mobilePopup.classList.remove('block');
                this.$mobilePopup.classList.add('hidden');
              }
              // 移除 resize 事件监听器，因为已经满足了条件
              window.removeEventListener('resize', resizeHandler);
            }
          };
          // 初始调用 resizeHandler，确保页面加载时正确设置
          resizeHandler();
          // 监听 window 的 resize 事件
          window.addEventListener('resize', resizeHandler);
        }
        // 左右切换菜单逻辑
        // 显示/隐藏滚动按钮
        updateButtons() {
          // 检查当前视窗宽度
          const viewportWidth = window.innerWidth;
          const scrollLeft = this.$scroller.scrollLeft;
          const maxScroll = this.$scroller.scrollWidth - this.$scroller.clientWidth;
          // 检查是否需要滚动（内容宽度是否大于容器宽度）
          const needsScroll = this.$scroller.scrollWidth > this.$scroller.clientWidth;

          // 重置所有按钮状态
          this.$prevBtn.classList.remove('opacity-40', 'opacity-100');
          this.$nextBtn.classList.remove('opacity-40', 'opacity-100');

          if (needsScroll) {
            // 先显示两个按钮
            this.$prevBtn.classList.remove('opacity-0');
            this.$nextBtn.classList.remove('opacity-0');

            // 检查是否到达边界
            const isAtStart = scrollLeft <= 0;
            const isAtEnd = scrollLeft >= maxScroll;

            // 更新左按钮状态（到达左边界时设置半透明）
            this.$prevBtn.classList.toggle('opacity-40', isAtStart);
            this.$prevBtn.classList.toggle('pointer-events-none', isAtStart);

            // 更新右按钮状态（到达右边界时设置半透明）
            this.$nextBtn.classList.toggle('opacity-40', isAtEnd);
            this.$nextBtn.classList.toggle('pointer-events-none', isAtEnd);
          } else {
            // 如果不需要滚动，完全隐藏两个按钮
            this.$prevBtn.classList.remove('opacity-40');
            this.$prevBtn.classList.add('opacity-0', 'pointer-events-none');
            this.$nextBtn.classList.remove('opacity-40');
            this.$nextBtn.classList.add('opacity-0', 'pointer-events-none');
          }
        }

        // 滚动处理
        scrollTo(direction) {
          const scrollAmount = 300;
          this.$scroller.scrollBy({
            left: direction === 'swiper-button-prev' ? -scrollAmount : scrollAmount,
            behavior: 'smooth',
          });
        }
        // 左右切换菜单逻辑 end
        // 清除遮罩层的方法
        clearExistingOverlays() {
          window.overlayManager.hide('header'); // 使用全局遮罩层管理器清除遮罩层
        }
      }
    );
  }
});
